import { TimeReportSessionTypeEnum } from '@app/shared/types/models/reports/time-report-panel.model';
import { WorkTimeReport } from '@app/shared/types/models/reports/work-time-report';
import moment from 'moment';

export const WORK_TIME_CHART_SERIES = [
  TimeReportSessionTypeEnum.STANDARD,
  TimeReportSessionTypeEnum.BANK_PLUS,
  TimeReportSessionTypeEnum.OVERTIME_50,
  TimeReportSessionTypeEnum.OVERTIME_100
] as const;

export type WorkTimeChartSeriesKey = (typeof WORK_TIME_CHART_SERIES)[number];

export function isWorkTimeChartSeries(value: TimeReportSessionTypeEnum): value is WorkTimeChartSeriesKey {
  return (WORK_TIME_CHART_SERIES as readonly TimeReportSessionTypeEnum[]).includes(value);
}

export function getWorkTimeChartDurationField(
  report: WorkTimeReport,
  series: WorkTimeChartSeriesKey
): string | undefined {
  switch (series) {
    case TimeReportSessionTypeEnum.STANDARD:
      return report.standardHoursDuration;
    case TimeReportSessionTypeEnum.BANK_PLUS:
      return report.bankHoursDuration;
    case TimeReportSessionTypeEnum.OVERTIME_50:
      return report.overtime50Duration;
    case TimeReportSessionTypeEnum.OVERTIME_100:
      return report.overtime100Duration;
  }
}

export function getWorkTimeChartDurations(report: WorkTimeReport): Record<WorkTimeChartSeriesKey, number> {
  return {
    [TimeReportSessionTypeEnum.STANDARD]: isoDurationToMinutes(
      getWorkTimeChartDurationField(report, TimeReportSessionTypeEnum.STANDARD)
    ),
    [TimeReportSessionTypeEnum.BANK_PLUS]: isoDurationToMinutes(
      getWorkTimeChartDurationField(report, TimeReportSessionTypeEnum.BANK_PLUS)
    ),
    [TimeReportSessionTypeEnum.OVERTIME_50]: isoDurationToMinutes(
      getWorkTimeChartDurationField(report, TimeReportSessionTypeEnum.OVERTIME_50)
    ),
    [TimeReportSessionTypeEnum.OVERTIME_100]: isoDurationToMinutes(
      getWorkTimeChartDurationField(report, TimeReportSessionTypeEnum.OVERTIME_100)
    )
  };
}

function isoDurationToMinutes(duration: string | undefined): number {
  if (!duration) {
    return 0;
  }
  const minutes = moment.duration(duration).asMinutes();
  return Number.isFinite(minutes) ? minutes : 0;
}
